
import {
    PropType,
    computed, defineComponent,
} from 'vue';
import {
    SnfTokenFixed,
} from '@redviking/argonaut-util/src/serial-numbers';
import { toWritableComputedProps } from '@redviking/argonaut-util/composables/writeable-computed-props';
import { useEditing } from 'src/components/EntityDetail';

const fixedTokenContentErrorMessage = (content: string) => {
    if (!content) {
        return 'Content cannot be empty';
    }
    if (content.includes(' ')) {
        return 'Content cannot contain white space';
    }
    return null;
};

export const fixedTokenConfigErrorMessage = (config: SnfTokenFixed) => {
    const endErrorMessage = fixedTokenContentErrorMessage(config.content);
    if (endErrorMessage) {
        return endErrorMessage;
    }

    return null;
};

export default defineComponent({
    name: 'FixedToken',
    props: {
        readonly: { type: Boolean, required: true },
        value: { type: Object as PropType<SnfTokenFixed>, required: true },
    },
    setup (props, { emit }) {
        const editing = useEditing.useInject().ref;
        const token = computed({
            get: () => props.value,
            set: v => emit('input', v),
        });

        const {
            content,
        } = toWritableComputedProps(token);

        return {
            editing,
            content,
            isValidContent: computed(() => fixedTokenContentErrorMessage(content.value)),
        };
    },
});
